import {
  FileCheck2,
  HardHat,
  ListChecks,
  ParkingSquare,
  Package,
  ShieldCheck,
  ArrowDown,
} from "lucide-react";const BENEFITS = [
  {
    icon: FileCheck2,
    title: "Devis rapide, gratuit et adapté",
    text:
      "Notre équipe vous propose une estimation claire selon votre volume, vos accès, votre distance, la date souhaitée et la formule choisie.",
  },
  {
    icon: HardHat,
    title: "Déménageurs professionnels",
    text:
      "Nos déménageurs sont habitués aux contraintes des logements franciliens : escaliers, ascenseurs, stationnement, accès étroits, meubles volumineux et objets fragiles.",
  },
  {
    icon: ListChecks,
    title: "Organisation personnalisée",
    text:
      "Chaque déménagement est étudié selon vos besoins afin de prévoir le matériel, les cartons, le véhicule, l'équipe et les solutions adaptées à votre situation.",
  },
  {
    icon: ParkingSquare,
    title: "Accompagnement pour le stationnement",
    text:
      "Nous pouvons vous accompagner dans les démarches liées aux autorisations de stationnement afin de faciliter l'intervention le jour du déménagement.",
  },
  {
    icon: Package,
    title: "Cartons et fournitures",
    text:
      "Des cartons et fournitures de déménagement peuvent être proposés pour préparer vos affaires dans de bonnes conditions, selon les besoins de votre prestation.",
  },
  {
    icon: ShieldCheck,
    title: "Protection et transport sécurisé",
    text:
      "Vos biens sont protégés avec soin pendant l'emballage, la manutention, le chargement et le transport grâce à du matériel adapté et une équipe expérimentée.",
  },
];



export default function PourquoiChoisir() {
  return (
    <section
      id="pourquoi-choisir"
      data-testid="pourquoi-choisir-section"
      className="relative py-10 sm:py-14 bg-white overflow-hidden"
    >
      {/* Editorial thin rules */}
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#5793d8]/30 to-transparent" aria-hidden="true" />

      <div className="bd-container">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          {/* LEFT sticky intro column */}
          <aside className="lg:col-span-5 lg:sticky lg:top-28 lg:self-start">
            <div className="flex items-center gap-3 text-[11px] font-bold tracking-[0.22em] uppercase text-[#237cb5]">
              <span className="h-px w-8 bg-[#237cb5]" aria-hidden="true" />
              Nos engagements
            </div>
            <h2 className="mt-6 font-extrabold tracking-tight text-[#0f1d2b] text-[26px] sm:text-[30px] lg:text-[36px] leading-[1.05]">
              Pourquoi choisir
              <br />
              <span style={{ color: "#237cb5" }}>Big Déménagement</span>
              <span className="text-[#5793d8]"> ?</span>
            </h2>

            <p className="mt-7 text-[#3a4a5a] text-base leading-relaxed">
              Basée à Paris, Big Déménagement accompagne particuliers et professionnels avec une organisation
              sérieuse, des formules adaptées et une prise en charge sécurisée de vos biens, de la préparation
              jusqu'à la livraison.
            </p>

            <div className="mt-8 flex items-center gap-2 text-[13px] font-semibold text-[#5b6b7a]">
              <ArrowDown className="h-4 w-4 animate-bounce text-[#237cb5]" />
              <span>6 engagements concrets</span>
            </div>

            <p className="mt-12 pt-8 border-t border-[#e6edf3] text-[#3a4a5a] leading-relaxed">
              Avec <strong className="text-[#0f1d2b]">Big Déménagement</strong>, vous bénéficiez d'un
              accompagnement clair, d'un service réactif et d'une organisation pensée pour déménager en toute
              sérénité.
            </p>
          </aside>

          {/* RIGHT numbered benefits list — 2 cols × 4 rows */}
          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-2">
              {BENEFITS.map(({ icon: Icon, title, text }, i) => (
                <article
                  key={title}
                  data-testid={`benefit-card-${i}`}
                  className="group relative py-6 border-b border-[#e6edf3] transition-colors"
                >
                  <div className="flex items-start gap-3">
                    <span
                      className="shrink-0 font-extrabold text-2xl leading-none text-[#dbe6f2] tabular-nums group-hover:text-[#5793d8] transition-colors"
                      aria-hidden="true"
                    >
                      0{i + 1}
                    </span>
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2.5">
                        <span
                          className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-[#eaf3fb] text-[#237cb5]"
                          aria-hidden="true"
                        >
                          <Icon className="h-4 w-4" />
                        </span>
                        <h3 className="font-bold text-[15px] text-[#0f1d2b] leading-snug">{title}</h3>
                      </div>
                      <p className="mt-2.5 text-[13.5px] leading-relaxed text-[#5b6b7a]">{text}</p>
                    </div>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
